/** 重要提醒 */

import request from '@/utils/request'

export default {
  /** 查询重要提醒 栏目 */
  queryMenuList(params) {
    return request({
      method: 'post',
      url: '/extendData/getMenu',
      params
    })
  },
  queryMachineCode() {
    return request({
      method: 'post',
      url: '/license/machineCode',
    })
  }
}